import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../app/theme";
import { colors } from "swyft-react-core";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  avatar: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    boxShadow: "0 5px 15px 0 rgba(0, 0, 0, 0.25)",
    backgroundColor: colors.white
  },
  logo: {
    width: "87px",
    [theme.breakpoints.up("md")]: {
      width: "112px"
    }
  },
  colorOrange: {
    color: color.orange
  },
  heroSection: {
    "display": "grid",
    "& *": {
      gridArea: "1 / 1"
    }
  },
  btnBookNow: {
    "width": "180px",
    "borderRadius": "18px",
    "boxShadow": "none",
    "height": "38px",
    "fontSize": "14px",
    "fontFamily": fontFamily.Axiforma,
    "& .MuiButton-label": { marginTop: "5px" },
    "&:hover": { boxShadow: "none" },
    [theme.breakpoints.down("sm")]: {
      "width": "272px",
      "& .MuiButton-label": { marginTop: "2px" }
    }
  },
  btnBookNowMobile: {
    "width": "100%",
    "borderRadius": "28px",
    "boxShadow": "none",
    "height": "40px",
    "fontSize": "16px",
    "letterSpacing": "0.22px",
    "fontFamily": fontFamily.Axiforma,
    "& .MuiButton-label": { marginTop: "5px" },
    "&:hover": { boxShadow: "none" }
  },
  btnLink: {
    "padding": 0,
    "& .MuiButton-label": {
      borderBottom: "1px solid #f7815c",
      color: "#f7815c",
      fontFamily: fontFamily.Axiforma,
      fontSize: "14px"
    }
  },
  btnLink2: {
    "padding": 0,
    "& .MuiButton-label": {
      borderBottom: "1px solid #f7815c",
      color: "#f7815c",
      fontFamily: fontFamily.Axiforma,
      fontSize: "14px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    }
  },
  navButton: {
    "padding": 0,
    "& .MuiButton-label": {
      fontSize: "16px",
      fontWeight: 500,
      letterSpacing: "0.5px",
      color: "#4b5462",
      fontFamily: fontFamily.Axiforma,
      [theme.breakpoints.up("md")]: {
        fontSize: "18px"
      }
    },
    "&:hover": {
      background: "transparent"
    }
  },
  table: {
    "& .MuiTableCell-root": { borderBottom: "none", paddingTop: "14px", paddingBottom: "14px" },
    "& .MuiTableCell-head": {
      color: "#43335b",
      fontSize: "12px",
      fontWeight: 700,
      lineHeight: 2,
      letterSpacing: "0.32px",
      fontFamily: fontFamily.Axiforma
    },
    "& .MuiTableCell-body": {
      color: "rgba(17, 21, 33, 0.65)",
      fontSize: "14px",
      fontWeight: 400,
      letterSpacing: "0.21px",
      fontFamily: fontFamily.Axiforma
    },
    "& tr:nth-of-type(odd)": {
      backgroundColor: colors.alternate
    },
    "& th": {
      backgroundColor: colors.white
    }
  },
  bulletPoint: {
    "&::before": {
      content: '"• "',
      paddingRight: "8px",
      fontSize: "1.5em",
      verticalAlign: "middle",
      color: color.orange,
      marginTop: "4px"
    }
  },
  iconOuterBox: {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "flexWrap": "wrap",
    "& > div:nth-child(4)": {
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2)
      }
    }
  }
}));
